export default "/fonts/vendor/katex/dist/KaTeX_Math-BoldItalic.woff?3f07ed67f06c720120cedd0bad5f60e2";